import {SettingParam} from "@/types/node";
import {Switch} from "@/components/ui/switch";
import {useEffect, useState} from "react";
import {cn} from "@/lib/utils";

export const SettingSwitch = ({
  param,
  handleChange,
  selectedNodeId,
  disabled = false,
}: {
  param: SettingParam;
  handleChange: (param: SettingParam, value: boolean) => void;
  selectedNodeId: string;
  disabled: boolean;
}) => {
  const [value, setValue] = useState(param.value || false);

  useEffect(() => {
    if (param.value !== value) {
      setValue(param.value || false);
    }
  }, [param, selectedNodeId]);

  return (
    <div className="mb-4 w-full">
      <label
        className={cn(
          "text-sm font-medium text-label mb-2 flex items-center gap-2 cursor-pointer",
          disabled && "opacity-50 pointer-events-none",
        )}
      >
        <Switch
          disabled={disabled}
          checked={value as boolean}
          onCheckedChange={value => {
            setValue(value);
            handleChange(param, value);
          }}
        />
        {param.label}
      </label>
    </div>
  );
};
